import { createContext, ReactNode, useEffect } from 'react';
import cookie from 'react-cookies';
import useThunkReducer, { ThunkDispatch } from 'react-hook-thunk-reducer';

import { setCommonSurvey, setSurveyButton } from '@r1-frontend/survey/context/actions';
import { SURVEY_COOKIE } from '@r1-frontend/survey/context/constants';
import { retrieveSurvey } from '@r1-frontend/survey/context/helpers/retrieveSurvey';
import { SurveyName, SurveyType } from '@r1-frontend/survey/context/surveys';

import initialState, { SurveyInitialState } from './reducer/initialState';
import reducer, { TSurveyActions } from './reducer';

export type SurveyCtxDispatch = ThunkDispatch<SurveyInitialState, TSurveyActions>

export type TCtx = {
    state: SurveyInitialState,
    dispatch: SurveyCtxDispatch,
    debugMode?: boolean,
    completedSurveys: Record<SurveyType, SurveyName | SurveyName[]>,
}

export const SurveyCtx = createContext<TCtx>({
    state: initialState,
    dispatch: () => null,
    debugMode: false,
    // @ts-ignore
    completedSurveys: {},
});

const SurveyContext = ({ children, debugMode = false }: { children: ReactNode, debugMode?: boolean }): JSX.Element => {
    const [state, dispatch] = useThunkReducer<SurveyInitialState, TSurveyActions>(reducer(debugMode), initialState);

    const completedSurveys = cookie.load(SURVEY_COOKIE) || {};

    useEffect(() => {
        const commonSurvey = retrieveSurvey();

        if (commonSurvey && 'survey' in commonSurvey) {
            dispatch(setCommonSurvey(commonSurvey.survey));
            dispatch(setSurveyButton(commonSurvey.button));
        }
    }, []);

    return <SurveyCtx.Provider value={{ state, dispatch, debugMode, completedSurveys }}>
        {children}
    </SurveyCtx.Provider>;
};

export default SurveyContext;
